// contactUs.fetchers — the footer enquiry on the wire.

import {
  BFF_ROUTES,
  ContactUsResponseSchema,
  type ContactUsRequest,
  type ContactUsResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * `POST /bff/contact-us` — store the enquiry in the operator queue.
 *
 * `bffPost` carries the session cookie and the captcha token (the route is in
 * `CAPTCHA_ROUTES`). Unlike the funnel's lead create, the BFF here FAILS LOUD:
 * a rejection means the message did not store, and the form must say so —
 * never swallow this into a fake thank-you.
 */
export async function postContactUs(request: ContactUsRequest): Promise<ContactUsResponse> {
  return bffPost(BFF_ROUTES.contactUs, request, ContactUsResponseSchema);
}
